export default __webpack_public_path__ + "static/media/capture-icon.97c2ae0e.svg";